import { render, staticRenderFns } from "./ViolationRule.vue?vue&type=template&id=38b1c3ca&scoped=true"
import script from "./ViolationRule.vue?vue&type=script&setup=true&lang=js"
export * from "./ViolationRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViolationRule.vue?vue&type=style&index=0&id=38b1c3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1c3ca",
  null
  
)

export default component.exports